import { useQuery } from '@tanstack/react-query'
import { BoosterProgramOverview } from 'Modules'

import { AppAdmin } from 'api/app-admin'
import { logError } from 'utils/logger'

import { boosterProgramKeys } from './query-keys'

const EMPTY_OVERVIEW: BoosterProgramOverview = {
  activePrograms: 0,
  totalPrograms: 0,
  activeEnrolledUsers: 0,
  codesIssued: 0,
  codeUsageRate: 0,
  newEnrollments: [],
}

const fetchOverview = async (): Promise<BoosterProgramOverview> => {
  try {
    const res = await AppAdmin.getBoosterProgramOverview()
    if (!res.data?.success || !res.data.data) return EMPTY_OVERVIEW
    return res.data.data
  } catch (error) {
    logError('Error fetching booster program overview:', error)
    return EMPTY_OVERVIEW
  }
}

export const useBoosterProgramOverview = () => {
  const query = useQuery({
    queryKey: boosterProgramKeys.overview(),
    queryFn: fetchOverview,
  })

  return {
    overview: query.data ?? EMPTY_OVERVIEW,
    isLoading: query.isLoading,
  }
}
